import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import React from "react";
import AuthService from "../../../AuthService";
import DrawerLinks from "./DrawerLinks";
import { Box, IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
const drawerWidth = 270;

const openedMixin = (theme) => ({
  width: "100%",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(10)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  variants: [
    {
      props: ({ open }) => open,

      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,

      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

const ScrollableList = styled(List)(({ theme }) => ({
  padding: 0,
  margin: 0,
  width: "100%",
  height: "100%",
  overflowY: "auto",
  maxHeight: "100vh",
  overflowX: "hidden",
  backgroundColor: theme.palette.secondary.main,
}));
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function AppDrawer({ open, isTemporaria, setOpen }) {
  const auth = new AuthService();
  const [empresa] = React.useState(auth.getProfile().empresa);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Drawer
      variant="permanent"
      open={open}
      onClose={isMobile ? () => {} : undefined}
      sx={[
        isMobile
          ? {
              width: "100%",
            }
          : {
              width: drawerWidth,
            },
        isMobile
          ? {
              "& .MuiDrawer-paper": {
                width: "100%",
              },
            }
          : {
              "& .MuiDrawer-paper": {
                width: open ? drawerWidth : `calc(${theme.spacing(10)})+1px`,
              },
            },
      ]}
    >
      <ScrollableList
        sx={{
          "&::-webkit-scrollbar": {
            width: "0.2rem",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            background: "rgba(10,23,55,0.2)",
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.5)",
          },
        }}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          height="90%"
          paddingTop={isTemporaria ? "2rem" : !open ? "4rem" : "0rem"}
          paddingLeft={open ? "0.25rem" : "0rem"}
        >
          <DrawerHeader
            sx={[
              {
                padding: "1rem",
                marginBottom: "-1.5rem",
              },
              isMobile
                ? {
                    display: "flex",
                  }
                : {
                    display: "none",
                  },
            ]}
          >
            <IconButton
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          </DrawerHeader>
          <Box>
            <DrawerLinks
              setOpen={setOpen}
              empresa={empresa}
              open={open}
              auth={auth}
            />
          </Box>
        </Box>
      </ScrollableList>
    </Drawer>
  );
}
